export default __webpack_public_path__ + "static/media/the-empress-pressed@2x.3de76ed6.png";